const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      link: '.js-download',
      tab: '.js-tabs-item',
    };

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    this.bindClickEvent();
  }

  bindClickEvent() {
    const link = $(this.selectors.link);
    link.on('click', event => {
      event.preventDefault();
      const target = $(event.currentTarget).data('tab');
      $(`${this.selectors.tab}[href=${target}]`).click();
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/downloads.js